import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconText1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"text-1"} maskId="square-filled-radius-0-stroke-1-IconText1"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V6H20V4H12.5V20H15V21H9V20H11.5V4H4V6H3V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconText1;
